module.exports = __webpack_public_path__ + "static/media/Amelia_Island_FL_History_Museum_Spanish_dock_mural_in_studio_1.5f7fd498.webp";